import { ModalProgrammatic } from '../modal/index'
import Variables from './Variables.vue'
import VariablesTextarea from './VariablesTextarea.vue'
import store from '../../store/index'

import {
  use,
  registerComponent,
  registerComponentProgrammatic,
} from '../../utils/plugins'

const fallback = (variable) => {
  console.warn(`Unable to insert ${variable} no insert method.`)
}

const VariablesProgrammatic = {
  open({ insert = fallback }) {
    const account = store.getters['session/account']
    const agency = store.getters['session/agency']
    ModalProgrammatic.open({
      component: Variables,
      props: {
        modal: true,
        insert,
        account,
        agency,
      },
      size: 'big',
      zIndex: 10000,
    })
  },
}

const Plugin = {
  install(Vue) {
    registerComponent(Vue, Variables)
    registerComponent(Vue, VariablesTextarea)
    registerComponentProgrammatic(Vue, 'variables', VariablesProgrammatic)
  },
}

use(Plugin)

export default Plugin

export { VariablesProgrammatic }
